function FormStatus(){
    return(
        <div className="form-submission">
            <h2 className="heading2">Your application has been successfully submited.<br></br>Your refrence number is 454545.</h2>
        </div>
    )
}export default FormStatus;